import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
import convertDataAttributes from '@widgets/shared/convertDataAttributes';
import BasketItems from '@widgets/BasketList/BasketItems';
import MiscItems from '@widgets/BasketList/MiscItems';
import { useForm } from 'react-hook-form';
import { Wrapper } from './styles';
function BasketList(props) {
    const { dataset } = props;
    const formattedAttributes = convertDataAttributes(dataset ?? {});
    console.log({ formattedAttributes });
    const { items, misc } = formattedAttributes;
    const form = useForm({
        mode: 'onChange',
        defaultValues: {},
    });
    return (_jsxs(Wrapper, { children: [_jsx(BasketItems, { items: items }), _jsx(MiscItems, { misc: misc })] }));
}
export default BasketList;
